import React from 'react';
import Register from '../../../components/UI/Register/Register';
 
const RegisterPage = () => {
  return  <Register></Register>  ;
}

export default RegisterPage;